import * as React from 'react'

import {
  PerformanceReviewProcessesDocument,
  ToggleArchivePerformanceReviewDocument,
} from 'generated/resources/graphql'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'

import { Review } from './types'

export const ToggleArchiveStatus: React.FC<{ review: Review }> = ({ review }) => {
  const archiveText = review.archived
    ? i18n.t('performance_process.reviews.archive_review.unarchive')
    : i18n.t('performance_process.reviews.archive_review.archive')
  const [toggleArchiveMutation, { loading }] = useMutation(ToggleArchivePerformanceReviewDocument, {
    extractorFn: (data) => data.performanceMutations.toggleArchivePerformanceReviewProcess,
  })

  const toggleArchive = async () => {
    const response = await toggleArchiveMutation({
      variables: {
        id: String(review.id),
      },
      refetchQueries: [
        {
          query: PerformanceReviewProcessesDocument,
          variables: {
            ids: [],
          },
        },
      ],
    })
    const result = handleResult(response, () => null)
    return result
  }

  return (
    <PopoverMenu.TouchableOption title={archiveText} onClick={toggleArchive} disabled={loading} />
  )
}
